import useRecipientGifters from './useRecipientGifters'
import useRecipientUsers from './useRecipientUsers'

const usePickedRecipient = (cosId: string) => {
  const { edges } = useRecipientGifters()
  const { recentRecipients } = useRecipientUsers()
  const recipient = [...(recentRecipients ?? []), ...edges.map((e) => e.node)].find(
    (r) => r?.cosId === cosId
  )

  return { recipient: recipient ?? undefined }
}

export default usePickedRecipient
